import { Trans } from '@lingui/macro'
import cx from 'classnames'

import styles from './Password.module.scss'
import {
    MIN_LENGTH,
    MIN_LOWERCASE,
    MIN_NUMBER,
    MIN_UPPERCASE,
} from './usePasswordStrength'

export const PasswordStrength = ({
    hasDigits,
    hasLength,
    hasLowerCase,
    hasUpperCase,
}: {
    hasDigits: boolean
    hasLength: boolean
    hasLowerCase: boolean
    hasUpperCase: boolean
}) => (
    <div className={styles.requirements}>
        <div
            className={cx(styles.requirement, {
                [styles.valid]: hasLength,
            })}
        >
            <Trans id="core.input.password.minCharacters">
                {MIN_LENGTH} Characters
            </Trans>
        </div>

        <div
            className={cx(styles.requirement, {
                [styles.valid]: hasUpperCase,
            })}
        >
            <Trans id="core.input.password.minUppercase">
                {MIN_UPPERCASE} Uppercase
            </Trans>
        </div>

        <div
            className={cx(styles.requirement, {
                [styles.valid]: hasLowerCase,
            })}
        >
            <Trans id="core.input.password.minLowercase">
                {MIN_LOWERCASE} Lowercase
            </Trans>
        </div>
        <div
            className={cx(styles.requirement, {
                [styles.valid]: hasDigits,
            })}
        >
            <Trans id="core.input.password.minNumber">
                {MIN_NUMBER} Number
            </Trans>
        </div>
    </div>
)
